export default{
    logo:'',
    navBars:{
                    active:'0',
                    list:[
                    
                    
                    {
                        name:'메인',
                        subActive:'0',
                        submenu:[
                         {
                            icon:'el-icon-s-data',
                            name:'대시보드',
                            type:'evo',
                            level:2,
                            pathname:'dashboard_index'
                        },
                         
                        {
                            icon:'el-icon-user',
                            name:'회원관리(LIST)',
                            type:'all',
                            admin:false,
                            pathname:'memlist_list'
                        },
                         {
                            icon:'el-icon-user',
                            name:'회원관리(TREE)',
                            type:'all',
                            admin:false,
                            pathname:'user_list'
                        },
                         {
                            icon:'el-icon-s-goods',
                            name:'알본사관리',
                             type:'evo',
                             admin:true,
                            pathname:'admin_list'
                        },
                        {
                            icon:'el-icon-files',
                            name:'본사관리',
                             type:'evo',
                             admin:false,
                            pathname:'bon_list'
                        },
                        {
                            icon:'el-icon-files',
                            name:'부본사관리',
                             type:'all',
                             admin:false,
                            pathname:'bubon_list'
                        },
                        {
                            icon:'el-icon-connection',
                            name:'총판관리',
                             type:'all',
                             admin:false,
                            pathname:'zp_list'
                        },
                         
                        {
                            icon:'el-icon-connection',
                            name:'매장관리',
                             type:'all',
                             admin:false,
                            pathname:'sp_list'
                        },
                        
                        
                       
                       
                        {
                            icon:'el-icon-document-copy',
                            name:'구매내역(RACE)',
                             type:'race',
                             admin:false,
                            pathname:'buy_list'
                        },
                         {
                            icon:'el-icon-document-copy',
                            name:'구매내역(EVO)',
                             type:'raceevo',
                             admin:false,
                            pathname:'betting_list1'
                        },

                        {
                            icon:'el-icon-document-copy',
                            name:'구매내역(파워볼)',
                             type:'power',
                             admin:false,
                            pathname:'order_list',
                            
                        },
                         {
                            icon:'el-icon-set-up',
                            name:'경주결과(RACE)',
                             type:'race',
                             admin:false,
                            pathname:'race_list'
                        },
                          {
                            icon:'el-icon-finished',
                            name:'경주내역(RACE)',
                             type:'race',
                             admin:false,
                            pathname:'racelist_list'
                        },

                         

                        {
                            icon:'el-icon-copy-document',
                            name:'배팅내역',
                             type:'evo',
                             admin:false,
                            pathname:'betting_list',
                            children: [{
                                icon:'el-icon-star-off',
                                name:'전체 배팅내역',
                                pathname:'betting_list1',

                            },{
                                icon:'el-icon-star-off',
                                name:'일자별 배팅현황',
                                pathname:'betting_list2',

                            },{
                                icon:'el-icon-star-off',
                                name:'일자별 게임별',
                                pathname:'betting_list3',

                            },{
                                icon:'el-icon-star-off',
                                name:'일자별 사용자별',
                                pathname:'betting_list4',

                            }]
                        },
                       
                         {
                            icon:'el-icon-attract',
                            name:'루징정산',
                            type:'aaa',
                            admin:false,
                            level:2,
                            pathname:'losinglist_list'
                        },
                        {
                            icon:'el-icon-attract',
                            name:'루징정산',
                            type:'aaa',
                            admin:false,
                            level:2,
                            pathname:'losinglist_bon'
                        },
                        {
                            icon:'el-icon-coin',
                            name:'입출금내역',
                             type:'all',
                             admin:false,
                            pathname:'money_list'
                        },
                         {
                            icon:'el-icon-tickets',
                            name:'수동충환내역',
                             type:'all',
                             admin:false,
                            pathname:'moneybak_list'
                        },
                        {
                            icon:'el-icon-tickets',
                            name:'롤링전환내역',
                             type:'evo',
                             admin:false,
                            pathname:'rolling_c_list'
                        },
                        {
                            icon:'el-icon-document-remove',
                            name:'손실금(RACE) ',
                             type:'race',
                             admin:false,
                            pathname:'lossrace_list'
                        },

                         {
                            icon:'el-icon-notebook-1',
                            name:'머니로그',
                             type:'evo',
                             admin:false,
                            pathname:'moneylogs_list',
                             children: [{
                                icon:'el-icon-star-off',
                                name:'회원머니로그',
                                pathname:'moneylogs_list_user',

                            },{
                                icon:'el-icon-star-off',
                                name:'파트너머니로그',
                                pathname:'moneylogs_list_pt',

                            }]
                        },
                         {
                            icon:'el-icon-notebook-1',
                            name:'머니로그',
                             type:'race',
                             admin:false,
                            pathname:'moneylogs_list',
                           
                        },

                         {
                            icon:'el-icon-notebook-1',
                            name:'머니로그',
                             type:'pp',
                             admin:false,
                            pathname:'moneylogs_list',
                           
                        },
                         {
                            icon:'el-icon-s-custom',
                            name:'일자별롤링',
                             type:'evo',
                             admin:false,
                            pathname:'rdp_list'
                        },
                         {
                            icon:'el-icon-bangzhu',
                            name:'정산관리',
                             type:'evo',
                             admin:false,
                            pathname:'calculation_list'
                        },{
                            icon:'el-icon-bangzhu',
                            name:'정산관리',
                             type:'pp',
                             admin:false,
                            pathname:'calculation_list'
                        },{
                            icon:'el-icon-bangzhu',
                            name:'정산관리(NEW)',
                            type:'evo',
                            level:2,
                            pathname:'calculation_new_list'
                        },
                       
                        
                        {
                            icon:'el-icon-bangzhu',
                            name:'정산관리',
                             type:'race',
                             admin:false,
                            pathname:'act_list'
                        },
                          {
                            icon:'el-icon-document-checked',
                            name:'출석체크',
                             type:'race',
                             admin:false,
                            pathname:'dcheck_list'
                        },
                          
                        {
                            icon:'el-icon-collection-tag',
                            name:'쪽지관리',
                             type:'evo',
                             admin:false,
                            pathname:'memo_list',
                             children: [{
                                icon:'el-icon-star-off',
                                name:'회원쪽지',
                                pathname:'memo_list_user',

                            },{
                                icon:'el-icon-star-off',
                                name:'파트너쪽지',
                                pathname:'memo_list_pt',

                            }]
                        },
                        {
                            icon:'el-icon-collection-tag',
                            name:'쪽지관리',
                             type:'race',
                             admin:false,
                            pathname:'memo_list',
                        },
                        {
                            icon:'el-icon-collection-tag',
                            name:'쪽지관리',
                             type:'pp',
                             admin:false,
                            pathname:'memo_list',
                        },
                        {
                            icon:'el-icon-chat-dot-square',
                            name:'고객센터',
                             type:'all',
                             admin:false,
                            pathname:'qa_list'
                        },
                        {
                            icon:'el-icon-notebook-1',
                            name:'게시판',
                            admin:false,
                             type:'all',
                            pathname:'board_list'
                        },
                        {
                            icon:'el-icon-edit-outline',
                            name:'팝업관리',
                             type:'all',
                             admin:false,
                            pathname:'alert_list'
                        },
                         
                         
                         
                         {
                            icon:'el-icon-edit',
                            name:'답변관리',
                             type:'all',
                             admin:false,
                            pathname:'autoqa_list'
                        },
                          {
                            icon:'el-icon-folder-checked',
                            name:'접속리스트',
                             type:'all',
                             admin:false,
                            pathname:'online_list'
                        },
                         /*{
                            icon:'el-icon-folder-checked',
                            name:'접속자현황',
                             type:'all',
                             admin:false,
                            pathname:'onlinenew_list'
                        },*/
                        {
                            icon:'el-icon-reading',
                            name:'접속로그',
                             type:'all',
                             admin:false,
                            pathname:'acclist_list'
                        },
                         {
                            icon:'el-icon-date',
                            name:'종합로그',
                             type:'all',
                             admin:false,
                            pathname:'log_list'
                        },
                        {
                            icon:'el-icon-s-tools',
                            name:'사이트설정',
                             type:'all',
                             admin:false,
                            pathname:'settings_list'
                        },
                        {
                            icon:'el-icon-s-tools',
                            name:'세팅관리',
                             type:'evo',
                             admin:true,
                            pathname:'settings_edit_list'
                        },

                         {
                            icon:'el-icon-document-copy',
                            name:'파워볼(바치기)',
                             type:'pp_out',
                             admin:false,
                            pathname:'orderoffer_list',
                            
                        },
                         {
                            icon:'el-icon-document-copy',
                            name:'구매내역(4조합)',
                             type:'ppgro',
                             admin:false,
                            pathname:'ordergro_list',
                            
                        },
                        
                      
                        
                        {
                            icon:'el-icon-monitor',
                            name:'파워볼 결과',
                             type:'power',
                             admin:false,
                            pathname:'powerball_list'
                        },
                        {
                            icon:'el-icon-copy-document',
                            name:'사다리결과',
                             type:'pp',
                             admin:false,
                            pathname:'sadari_list'
                        },

                        {
                            icon:'el-icon-monitor',
                            name:'파워볼 결과(보글)',
                             type:'pp3',
                             admin:false,
                            pathname:'powerball_bg_list'
                        },
                        {
                            icon:'el-icon-copy-document',
                            name:'사다리결과(보글)',
                             type:'pp3',
                             admin:false,
                            pathname:'sadari_bg_list'
                        },
                        {
                            icon:'el-icon-baseball',
                            name:'게임관리',
                             type:'evo',
                             admin:true,
                            pathname:'game_list'
                        },
                        {
                            icon:'el-icon-baseball',
                            name:'게임관리(아너)',
                             type:'evo',
                             admin:false,
                            pathname:'gamehn_list'
                        },
                        ,{
                            icon:'el-icon-baseball',
                            name:'게임관리(오라클)',
                             type:'evo',
                             admin:false,
                            pathname:'gamespnew_list'
                        },
                        {
                            icon:'el-icon-baseball',
                            name:'게임관리(파싱)',
                             type:'evo',
                             admin:false,
                            pathname:'gamegd_list'
                        },
                         
                        {
                            icon:'el-icon-s-ticket',
                            name:'쿠폰관리',
                             type:'evo',
                             admin:false,
                            pathname:'coupon_list'
                        },
                         {
                            icon:'el-icon-delete',
                            name:'삭제요청',
                             type:'evo',
                             admin:false,
                            pathname:'delac_list'
                        },
                        //  {
                        //     icon:'el-icon-postcard',
                        //     name:'기본설정',
                        //      type:'evo',
                        //      admin:false,
                        //     pathname:'configlist_list'
                        // },
                        //   {
                        //     icon:'el-icon-s-platform',
                        //     name:'사이트현황',
                        //      type:'evo',
                        //      admin:false,
                        //     pathname:'sitestat_list'
                        // },
                        //   {
                        //     icon:'el-icon-money',
                        //     name:'입츨금통계',
                        //      type:'evo',
                        //      admin:false,
                        //     pathname:'moneystat_list'
                        // },
                        //  {
                        //     icon:'el-icon-wallet',
                        //     name:'롤링금통계',
                        //      type:'evo',
                        //      admin:false,
                        //     pathname:'rollingstat_list'
                        // }
                        ]
                    },
                    
                    

                    ]

                }
                
                
            
}


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = null
// module chunks = 